import { jenisMeta, STATUS_STYLES } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const JenisTag = ({ jenis }) => {
  const { icon: Icon } = jenisMeta(jenis);
  return (
    <span className="inline-flex items-center gap-1.5 rounded-lg bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-700">
      <Icon className="h-3.5 w-3.5 text-emerald-600" /> {jenis}
    </span>
  );
};

export const StatusBadge = ({ status }) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES.Menunggu;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold", style.badge)}>
      <span className={cn("h-1.5 w-1.5 rounded-full", style.dot)} /> {status}
    </span>
  );
};

export const NewReplyBadge = ({ id }) => (
  <span className="ml-2 inline-flex items-center gap-1 rounded-full bg-rose-50 px-2 py-0.5 text-[11px] font-semibold text-rose-700 ring-1 ring-rose-200" data-testid={`new-reply-badge-${id}`}>
    <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-rose-500" /> Balasan baru
  </span>
);
